import {
  AnalyticsReportTypeSettingsConfig,
  AnalyticsReportTypes,
} from '~/data/reports';
import { SavedReportSettings } from '~/data/reportSettings';
import { Roles } from '~/data/user';

import { UseReportDatasetOutput } from '../../ReportDatasetSelector';

export * from './dataGrid';
export * from './includeSettings';

export const canSaveSharedSettingsUserRoles: Roles[] = [
  Roles.HR_ADMIN,
  Roles.HR_ADMIN_LIMITED,
  Roles.HR_STAFF,
];

export const validateSavedReportSettings = <P>(
  savedSettingsList: SavedReportSettings<P>[],
  reportDataset?: UseReportDatasetOutput<P>,
): SavedReportSettings<P>[] => {
  if (!reportDataset) {
    return [];
  }

  const { reportConfig, defaultReportSelection } = reportDataset;

  const {
    options: { types, roles, legalEntities, units },
  } = reportConfig;

  const overrideReportTypeProps = (
    settings: SavedReportSettings<P>,
    overrideReportType: Partial<AnalyticsReportTypeSettingsConfig>,
  ): SavedReportSettings<P> => {
    if (!!settings.settingsConfig?.reportSelection?.reportType) {
      return {
        ...settings,
        settingsConfig: {
          ...settings.settingsConfig,
          reportSelection: {
            ...settings.settingsConfig.reportSelection,
            reportType: {
              ...settings.settingsConfig.reportSelection.reportType,
              ...overrideReportType,
            },
          },
        },
      };
    }

    return settings;
  };

  return savedSettingsList
    .filter((savedSettings) => {
      const savedReportSelection =
        savedSettings.settingsConfig?.reportSelection;

      if (!!savedReportSelection) {
        const {
          reportType: { type, role, unitId, legalEntityId },
        } = savedReportSelection;

        if (!types.includes(type)) {
          return false;
        }

        switch (type) {
          case AnalyticsReportTypes.Unit:
            return units.includes(unitId);
          case AnalyticsReportTypes.LegalEntity:
            return legalEntities.includes(legalEntityId);
          case AnalyticsReportTypes.Team:
            return roles.includes(role);
          case AnalyticsReportTypes.HR:
          case AnalyticsReportTypes.Employee:
          case AnalyticsReportTypes.Company:
          default:
            return true;
        }
      }

      return true;
    })
    .map((savedSettings): SavedReportSettings<P> => {
      const savedReportSelection =
        savedSettings.settingsConfig?.reportSelection;

      if (!!savedReportSelection) {
        return overrideReportTypeProps(savedSettings, {
          employeeId: defaultReportSelection.reportType.employeeId,
        });
      }

      return savedSettings;
    });
};
